import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import TableCell from '@material-ui/core/TableCell';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//Ícones
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//Componentes
import GenericListPage from './GenericListPage';
import MaskedInput from 'react-text-mask';
//Controller
import ClienteController from '../controllers/ClienteController';
import ClienteAvaliadorController from '../controllers/ClienteAvaliadorController';
import PermissaoController from '../controllers/PermissaoController';
//Utils
import formatarCpfCnpj from '../utils/formatarCpfCnpj';
import { MascaraCPF } from '../utils/mascara';

/**
 * Página para a listagem e filtro de clientes
 */
class ClienteListPage extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleRenderItem = this.handleRenderItem.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        //Inicializa os controllers
        this.clienteController = new ClienteController();
        this.clienteAvaliadorController = new ClienteAvaliadorController();
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            permiteCadastrarCliente: false,
            nome: '',
            cpf: '',
            inativos: false,
            perfilUsuario: null,
            usuarioLogado: null
        };
    }

    async componentDidMount() {
        const permiteCadastrarCliente = await this.permissaoController.permiteCadastrarCliente();
        const perfilUsuario = await this.permissaoController.retornarPerfil();
        const usuarioLogado = await this.permissaoController.retornarUsuario();
        this.setState({
            permiteCadastrarCliente,
            perfilUsuario,
            usuarioLogado
        });
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Trata as alterações nos checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleCheckboxChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.checked;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Evento disparado para obter os parâmetros do filtros
     * @return {Object} Retorna os parâmetros informados pelo usuário
     */
    handleFilter() {
        //Recupera os parâmetros preenchidos pelo usuário
        const { nome, cpf, inativos, perfilUsuario, usuarioLogado } = this.state;
        const params = { nome, cpf, inativos };

        //Aplica filtro automático por avaliador apenas para o perfil AVALIADOR
        if (perfilUsuario === 4 && usuarioLogado) { // 4 = AVALIADOR
            params.avaliador = usuarioLogado.id;
        }

        //Repassa os parâmetros para o filtro
        return params;
    }

    //Função para renderizar os itens
    handleRenderItem(item) {
        return (
            <React.Fragment>
                <TableCell>{item.nome}</TableCell>
                <TableCell>{formatarCpfCnpj(item.cpf)}</TableCell>
                <TableCell>{item.avaliador || 'Não atribuído'}</TableCell>
            </React.Fragment>
        );
    }

    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { permiteCadastrarCliente, nome, cpf, inativos } = this.state;

        return (
            <GenericListPage resource="cliente" controller={this.clienteController} readOnly={!permiteCadastrarCliente} columnNames={['Nome', 'CPF', 'Avaliador']} onRenderItem={this.handleRenderItem} onLogout={onLogout} onFilter={this.handleFilter} usuario={usuario} empresa={empresa} permissoes={permissoes} >
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={8} lg={6} >
                                <TextField
                                    name="nome"
                                    label="Nome"
                                    type="text"
                                    placeholder="Nome do avaliador"
                                    variant="outlined"
                                    fullWidth
                                    value={nome}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={4} >
                                <TextField
                                    name="cpf"
                                    label="CPF"
                                    type="text"
                                    placeholder="CPF do formando"
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{ inputComponent: MaskedInput, inputProps: { mask: MascaraCPF } }}
                                    value={cpf}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <FormControl fullWidth variant="standard" >
                                    <FormControlLabel
                                        id="inativos-label"
                                        control={
                                            <Checkbox
                                                checked={inativos}
                                                onChange={this.handleCheckboxChange}
                                                name="inativos"
                                                color="primary"
                                            />
                                        }
                                        label="Exibir inativos"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} container justify="flex-end" >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </GenericListPage>
        );
    }
}

ClienteListPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired
};

export default ClienteListPage;